const RAW_UNSAFE_CHARACTERS = /[\s\p{Cc}\\]/u;
const LOOPBACK_CALLBACK = /^http:\/\/127\.0\.0\.1:([1-9]\d{3,4})\/callback(?:\/([A-Za-z0-9_-]{8,128}))?$/u;

/** Validate hosted OAuth callback URLs while allowing the canonical native loopback callback form. */
export function isAllowedHostedCallbackUrl(value: unknown): boolean {
  if (typeof value !== 'string' || value.length < 1 || value.length > 500 || RAW_UNSAFE_CHARACTERS.test(value)) {
    return false;
  }

  const loopback = LOOPBACK_CALLBACK.exec(value);
  if (loopback != null) {
    const port = Number(loopback[1]);
    return port >= 1024 && port <= 65_535;
  }

  let parsed: URL;
  try {
    parsed = new URL(value);
  } catch {
    return false;
  }
  return parsed.protocol === 'https:'
    && parsed.username === ''
    && parsed.password === ''
    && parsed.hash === '';
}
